import React, { useState } from "react";
import "./FAQPopover.scss";
import { useAuth } from "../context/AuthContext";

const FAQPopover: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  return (
    <div className="faq-popover-container">
      <button
        className="faq-popover-btn"
        onClick={() => setOpen((o) => !o)}
        title="Frequently Asked Questions"
      >
        FAQ
      </button>
      {open && (
        <div className="faq-popover-content">
          <h4>What can everyone do?</h4>
          <ul>
            <li>
              <b>Upload files</b> for analysis and see results.
            </li>
            <li>
              <b>See live community scans</b> from all users.
            </li>
          </ul>
          <h4>What can signed-in users do?</h4>
          <ul>
            <li>
              <b>View your own uploaded files</b> in one place.
            </li>
            <li>
              <b>Make uploads private</b> so only you can see them.
            </li>
            <li>
              <b>Favorite scans</b> to quickly find them later.
            </li>
            <li>
              <b>Access the URL scanner</b> to scan websites for threats.
            </li>
          </ul>
          {!isAuthenticated && <p>Sign in to unlock more features!</p>}
        </div>
      )}
    </div>
  );
};

export default FAQPopover;
